<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Effective Interactive Session between the Exchange Program of
      Proyash-Chattogram with Chittagong Grammar School - CGS
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        It was an excellent exchange program of Proyash-Chattogram with
        Chittagong Grammar School - CGS. Mutual participation of students in
        painting, gardening, games, handwriting and cultural shows of the both
        the schools created an extraordinary team work. <br /><br />
        Thanks to Chittagong Grammar School for being so compassionate towards
        the cause of children with special needs..the more we are together the
        more we are near to inclusion.
        <br /><br />
        চট্টগ্রাম গ্রামার স্কুলের সাথে প্রয়াস-চট্টগ্রামের একটি চমৎকার বিনিময়
        অনুষ্ঠান হল... উভয় বিদ্যালয়ের চিত্রাঙ্কন, বাগান, খেলা, হাতের লেখা এবং
        সাংস্কৃতিক অনুষ্ঠানে শিক্ষার্থীদের পারস্পরিক অংশগ্রহণ একটি অসাধারণ টিম
        ওয়ার্ক তৈরি করেছে। চট্টগ্রাম গ্রামার স্কুল'কে ধন্যবাদ বিশেষ চাহিদা
        সম্পন্ন শিশুদের প্রতি সহানুভূতিশীল আচরণের জন্য। আমরা যত বেশি একসাথে থাকি
        ততই আমরা অন্তর্ভুক্তির দিকে অগ্রসর হব।
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
